const EyeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12.0001 18.9995C11.1581 18.9995 10.3151 18.8215 9.49609 18.5045"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.882 12.4688C18.99 15.9678 15.495 19.0008 12 19.0008"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0791 8.92188C19.7701 9.73088 20.3841 10.6129 20.8821 11.5339C21.0391 11.8249 21.0391 12.1779 20.8821 12.4689"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19L19 5"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.77309 14.2271C8.54309 12.9971 8.54309 11.0021 9.77309 9.77211C11.0031 8.54211 12.9981 8.54211 14.2281 9.77211"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0442 6.956C15.4972 5.759 13.7482 5 12.0002 5C8.50524 5 5.01024 8.033 3.11824 11.533C2.96124 11.824 2.96124 12.177 3.11824 12.468C4.06424 14.217 5.41024 15.849 6.95624 17.045"
        stroke="#616161"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeIcon;
